import urlPrefix from "./apiPrefix";

export const putTaxRateUpdate = () => `${urlPrefix.value}/tax-web-control/api/tax-rate/update`;
export const postTaxRateCreate = () => `${urlPrefix.value}/tax-web-control/api/tax-rate/create`;
export const getTaxRate = (id: number) => `${urlPrefix.value}/tax-web-control/api/tax-rate/${id}`;
export const getTaxRateUpdated = () => `${urlPrefix.value}/tax-web-control/api/tax-rate/updated`;
export const getTaxRateList = () => `${urlPrefix.value}/tax-web-control/api/tax-rate/list`;
export const getTaxRateListActive = () => `${urlPrefix.value}/tax-web-control/api/tax-rate/listActive`;
export const deleteTaxRate = (id: number) => `${urlPrefix.value}/tax-web-control/api/tax-rate/delete/${id}`;
